import {useFlag, useFlagsStatus} from '@unleash/proxy-client-react';
import useExperiment from './useExperiment';
import getOverrideParams from '../utils/parseUrlParams';
import {
  EXPERIMENT_CONFIGS,
  EXPERIMENT_SHOP_BY_INTEREST,
} from '../constants/experiments';

const {control} = EXPERIMENT_CONFIGS[EXPERIMENT_SHOP_BY_INTEREST].qa.variants;

const useShopByInterestExperiment = ({
  experimentName,
  isFeatureReady = false,
}) => {
  const config = EXPERIMENT_CONFIGS[experimentName]?.[process.env.ENV];
  const {experimentId, featureFlag} = config ?? {};

  const override = getOverrideParams(experimentId);
  const hasOverride = !!override;

  const {flagsReady} = useFlagsStatus();
  const isFlagEnabled = useFlag(featureFlag);

  const shouldUseExperiment =
    !hasOverride && flagsReady && isFlagEnabled && isFeatureReady;

  const {isLoading, variant: hookVariant} = useExperiment({
    name: experimentName,
    isEnabled: shouldUseExperiment,
  });

  let resolvedVariant = override || hookVariant;

  let isExperimentLoading = true;

  if (!hasOverride) {
    if ((!isFlagEnabled || !flagsReady) && !shouldUseExperiment) {
      isExperimentLoading = false;
      resolvedVariant = control.id;
    } else if (isFlagEnabled) {
      isExperimentLoading = isLoading || false;
    }
  } else {
    isExperimentLoading = false;
  }

  return {
    experimentId,
    variant: resolvedVariant,
    isExperimentLoading,
  };
};

export default useShopByInterestExperiment;
